// extracted by extract-css-chunks-webpack-plugin
module.exports = {"order-status-details":"OrderStatusDetails-220bbc0667a139d7","detail-card":"OrderStatusDetails-65b6714ac438ed54","hide-on-mobile":"OrderStatusDetails-7acf34ef0ec17c8a"};